module.exports = __webpack_public_path__ + "static/media/percent.561e8d32.svg";